import { RouterProvider } from "react-router-dom";
import router from "./routes/AppRoutes";
import { useEffect, useRef, useState } from "react";
import LoadingBar from "react-top-loading-bar";
import { setLoadingFunctions } from "./http/HttpRequest";
import { ToastContainer } from "react-toastify";


function App() {
  const topLoadingBarRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setLoadingFunctions({
      startLoading: () => {
        setIsLoading(true);
        if (topLoadingBarRef.current) {
          topLoadingBarRef.current.continuousStart();
        }
      },
      completeLoading: () => {
        setIsLoading(false);
        if (topLoadingBarRef.current) {
          topLoadingBarRef.current.complete();
        }
      },
    });
  }, []);
  return (
  <>
    <LoadingBar ref={topLoadingBarRef} color="#a83232" />
    <ToastContainer />
    <RouterProvider router={router} />
  </>

  )
}

export default App;
